import * as angular from "angular";
import {IController} from "angular";
import { LeanPlanningService } from "../../services/lean-planning-service.service";
import {RoutesService} from "../../../routes/services/routes-service.service";
import {RouteModel} from "../../../routes/models/route.model";
import {LogisticsVehicleReferenceModel} from "../../../logistics-vehicle/models/logistics-vehicle-reference.model";
import {AssignIgnoreScoreOptionType} from "../../../deliveries/types/assign-ignore-score-option.type";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {AgentReference} from "../../../agents/angular/models/agentReference.model";

export class RouteResourcesAssignmentComponent implements IController {
  routeIds: string[];
  step: 'agent-assign' | 'agent-associate' | 'assistant' | 'vehicle' = 'agent-assign';
  route?: RouteModel;

  // public route: RouteModel | undefined = undefined;
  public serviceIds: string[];

  public selectedAssistantIds: string[] = [];
  public excludedAssistantIds: string[] = [];


  public mainVehicle: LogisticsVehicleReferenceModel;
  public attachedVehicle: LogisticsVehicleReferenceModel;
  public isIgnoreScore: boolean = false;
  public isShowAllToggleVisible: boolean = true;
  public agentAssignmentSuccess: boolean | undefined = undefined;
  public agentAssociateSuccess: boolean | undefined = undefined;
  public assistantAssignmentSuccess: boolean | undefined = undefined;
  public vehicleAssignmentSuccess: boolean | undefined = undefined;

  constructor(private $scope,
              private $route,
              private siteContextService: SiteContextService,
              private leanPlanningService: LeanPlanningService,
              private routesService: RoutesService,
  ) { }

  $onInit() {
    const assignIgnoreScoreOption = this.siteContextService.getSiteInfo().assignIgnoreScoreOption;

    if (assignIgnoreScoreOption === AssignIgnoreScoreOptionType.ShowDefaultOn) {
      this.isIgnoreScore = true;
    } else if (assignIgnoreScoreOption === AssignIgnoreScoreOptionType.ShowDefaultOff) {
      this.isIgnoreScore = false;
    } else if (assignIgnoreScoreOption === AssignIgnoreScoreOptionType.Hide) {
      this.isIgnoreScore = false;
      this.isShowAllToggleVisible = false;
    }

    if (this.route) {
      this._initAssistants();
      this._initVehicles();
    }
  }

  _initAssistants() {
    if (this.route?.agentId) {
      this.excludedAssistantIds = [this.route.agentId];
    }

    this.route?.assistantAgentReferences?.forEach((a: AgentReference) => {
      this.selectedAssistantIds = (this.selectedAssistantIds || []).concat(a.id);
    });
  }

  private _initVehicles() {
    if (this.route) {
      this.mainVehicle = this.route.planningResource?.mainLogisticsVehicleReference;
      this.attachedVehicle = this.route.planningResource?.attachedLogisticsVehicleReferences?.length ?
        this.route.planningResource?.attachedLogisticsVehicleReferences[0] :
        undefined;
    }
  }

  $onChanges(changes) {

  }

  onAssociateAgent(agent) {
    this.routesService.associateAgent(this.routeIds, agent.id)
      .then(() => {
        this.agentAssociateSuccess = true;
        this.step = 'agent-assign';
      }).catch(() => {
        this.agentAssociateSuccess = false;
      });
  }

  onAssignAgent(agent) {
    this.leanPlanningService.assignRoutesToAgent(this.routeIds, agent.id, true)
      .then(() => {
        this.agentAssignmentSuccess = true;
        this.step = 'assistant';
      }).catch(() => {
        this.agentAssignmentSuccess = false;
      });
  }

  onAssignAssistant(assistantIds: string[]) {
    this.routesService.assignAssistants(this.routeIds, assistantIds)
      .then(() => {
        this.assistantAssignmentSuccess = true;
        this.step = 'vehicle';
      }).catch(() => {
        this.assistantAssignmentSuccess = false;
      });
  }

  onAssignVehicle() {
    const mainLogisticVehicleId = this.mainVehicle ? this.mainVehicle.id : undefined;
    const attachedLogisticVehicleIds = this.attachedVehicle ? [this.attachedVehicle.id] : undefined;

    this.routesService.assignLogisticVehicles(this.routeIds, mainLogisticVehicleId, attachedLogisticVehicleIds)
      .then(() => {
        this.vehicleAssignmentSuccess = true;
      }).catch(() => {
        this.vehicleAssignmentSuccess = false;
    });
  }

  onSelectMainVehicle(vehicle) {
    this.mainVehicle = vehicle;
  }

  onSelectAttachedVehicle(vehicle) {
    this.attachedVehicle = vehicle;
  }

  onToggleIsIgnoreScore(isIgnoreScore: boolean) {
    this.isIgnoreScore = isIgnoreScore;
  }
}

angular
  .module('bringoz.admin.lean-planning')
  .component('routeResourcesAssignment', {
    bindings: {
      routeIds: '<',
      step: '<',
      route: '<?'
    },
    template: require('./route-resources-assignment.html').default,
    controller: RouteResourcesAssignmentComponent,
  });
